import { useEffect } from "react";
import { useSettings } from "@/context/SettingsContext";

function hexToRgb(hex) {
  const m = (hex || "").replace("#", "");
  const full = m.length === 3 ? m.split("").map((c) => c + c).join("") : m;
  const n = parseInt(full, 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function darken(hex, amt = 0.14) {
  const [r, g, b] = hexToRgb(hex);
  const f = (v) => Math.max(0, Math.round(v * (1 - amt)));
  return "#" + [f(r), f(g), f(b)].map((v) => v.toString(16).padStart(2, "0")).join("");
}

const OVERRIDES = `
.bg-\\[\\#E85D2A\\]{background-color:var(--pp-primary)!important}
.hover\\:bg-\\[\\#E85D2A\\]:hover{background-color:var(--pp-primary)!important}
.group:hover .group-hover\\:bg-\\[\\#E85D2A\\]{background-color:var(--pp-primary)!important}
.hover\\:bg-\\[\\#D04A1B\\]:hover{background-color:var(--pp-primary-hover)!important}
.text-\\[\\#E85D2A\\]{color:var(--pp-primary)!important}
.hover\\:text-\\[\\#E85D2A\\]:hover{color:var(--pp-primary)!important}
.group:hover .group-hover\\:text-\\[\\#E85D2A\\]{color:var(--pp-primary)!important}
.border-\\[\\#E85D2A\\]{border-color:var(--pp-primary)!important}
.fill-\\[\\#E85D2A\\]{fill:var(--pp-primary)!important}
.bg-\\[\\#E85D2A\\]\\/10{background-color:rgba(var(--pp-primary-rgb),0.1)!important}
.bg-\\[\\#E85D2A\\]\\/5{background-color:rgba(var(--pp-primary-rgb),0.05)!important}
.bg-\\[\\#E85D2A\\]\\/20{background-color:rgba(var(--pp-primary-rgb),0.2)!important}
.group:hover .group-hover\\:bg-\\[\\#E85D2A\\]\\/10{background-color:rgba(var(--pp-primary-rgb),0.1)!important}
.hover\\:border-\\[\\#E85D2A\\]\\/30:hover{border-color:rgba(var(--pp-primary-rgb),0.3)!important}
.focus\\:ring-\\[\\#E85D2A\\]\\/30:focus{--tw-ring-color:rgba(var(--pp-primary-rgb),0.3)!important}
.from-\\[\\#E85D2A\\]{--tw-gradient-from:var(--pp-primary) var(--tw-gradient-from-position)!important;--tw-gradient-to:rgba(var(--pp-primary-rgb),0) var(--tw-gradient-to-position)!important;--tw-gradient-stops:var(--tw-gradient-from),var(--tw-gradient-to)!important}
::selection{background:var(--pp-primary)!important;color:#fff!important}
`;

export default function ThemeInjector() {
  const { settings } = useSettings();
  useEffect(() => {
    const primary = settings?.theme_primary || "#E85D2A";
    const [r, g, b] = hexToRgb(primary);
    const css = `:root{--pp-primary:${primary};--pp-primary-hover:${darken(primary)};--pp-primary-rgb:${r},${g},${b}}` + OVERRIDES;
    let el = document.getElementById("pp-theme");
    if (!el) {
      el = document.createElement("style");
      el.id = "pp-theme";
      document.head.appendChild(el);
    }
    el.textContent = css;
  }, [settings]);
  return null;
}
